// plugins/api.js

import createApi from '../store/api';

export default ({ $mrApi, $mrApiV2, $axios }, inject) => {
  const api = createApi($mrApi, $mrApiV2, $axios);
  inject('api', api);
};
